import { AdminService } from '../services/adminService';
import {
  FILTRES_PAR_DEFAUT,
  ecrireFiltresListe,
  ecrirePageListe,
  parametresApiListe,
} from './exerciseListFilters';

/**
 * Construit les paramètres d'URL pour la liste exercices (taxonomie + type de jeu).
 */
export function buildExerciseListSearchParams({
  gameType,
  domain,
  competence,
  notion,
} = {}) {
  const params = new URLSearchParams();
  if (gameType) params.set('gameType', gameType);
  if (domain !== undefined && domain !== null) params.set('domain', domain);
  if (competence !== undefined && competence !== null) params.set('competence', competence);
  if (notion !== undefined && notion !== null) params.set('notion', notion);
  return params;
}

/**
 * Filtres de la liste ouverte depuis la couverture taxonomique : la case
 * cliquée et rien d'autre. Les filtres d'une visite précédente (source,
 * recherche…) ne s'y ajoutent plus : le compte affiché dans la case doit être
 * celui de la liste ouverte, et la couverture ne compte que les actifs.
 */
export function persistExerciseListFilters(filters = {}) {
  const next = {
    ...FILTRES_PAR_DEFAUT,
    active: 'true',
    gameType: filters.gameType || '',
  };
  if (filters.domain !== undefined && filters.domain !== null) {
    next.domain = filters.domain;
    next.competence = filters.competence ?? '';
    next.notion = filters.notion ?? '';
  }
  ecrirePageListe(1);
  return ecrireFiltresListe(next);
}

export function navigateToExerciseList(navigate, filters = {}) {
  persistExerciseListFilters(filters);
  const params = buildExerciseListSearchParams(filters);
  const qs = params.toString();
  navigate(qs ? `/admin/exercises?${qs}` : '/admin/exercises');
}

/**
 * Ouvre le premier exercice de la liste ainsi filtrée (édition) — le même que
 * la liste afficherait en tête, puisque la requête est la même.
 * Retombe sur la liste si aucun résultat.
 */
export async function navigateToFirstExercise(navigate, filters = {}) {
  const filtres = persistExerciseListFilters(filters);
  try {
    const { exercises } = await AdminService.getExercises({ ...parametresApiListe(filtres), page: 1, limit: 1 });
    const first = exercises?.[0];
    if (first?.id) {
      navigate(`/admin/exercises/edit/${first.id}`);
      return { found: true, id: first.id };
    }
  } catch (error) {
    console.error('Erreur lors de la recherche du premier exercice:', error);
  }
  navigateToExerciseList(navigate, filters);
  return { found: false };
}
